<template>
  <div class="modal fade" id="staticBackdrop" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered overlay-background2">
      <div class="modal-content overlay-background">
        <div class="m-2 mt-2 d-flex align-items-center justify-content-end flex-wrap">
          <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body mb-5">
          <img height="auto" width="auto" :src="selectedImg" class="text-white enlarged-image" alt="ops.. sem imagem">
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="processDetailModal" tabindex="-1" aria-labelledby="processDetailModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content" v-if="detailItem">
        <div class="modal-header bg-dark text-white">
          <h5 class="modal-title" id="processDetailModalLabel">
            Serviço N° {{ detailItem.id + 1000 }}
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" ref="detailCloseBtn"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">

              <div class="d-flex justify-content-between align-items-center mb-3 flex-nowrap">
                <div class="detail-thumb-wrapper">
                  <img
                    v-if="selectedImg"
                    :src="selectedImg"
                    class="detail-thumb clickable"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    alt="preview do serviço"
                  />
                  <div v-else class="detail-thumb-placeholder text-secondary small d-flex align-items-center justify-content-center">
                    Sem imagem
                  </div>
                  <button
                    v-if="hasMidia[detailItem.id]"
                    class="detail-thumb-download"
                    title="Baixar mídia"
                    @click.stop="downloadMidia(detailItem.id)"
                  >
                    <font-awesome-icon icon="download" style="width: 25px;height: auto;"/>
                  </button>
                </div>

                <span :class="`status badge bg-${backgroundColorStage(detailItem.stage)} text-wrap ms-2`">
                  <b>Etapa: </b> {{ stateFormat(detailItem) }}
                </span>
              </div>

              <span class="produto"><b>Cliente:</b> {{ findClient(detailItem) }}</span>
              <br class="mb-2" />
              <span class="designer"><b>Material: </b>{{ getMaterial(detailItem) }}</span>
              <br class="mb-2" />
              <span class="designer"><b>Designer: </b> {{ resolveDesignerName(detailItem) }}</span>
              <br class="mb-2" />
              <span v-if="detailItem.productor" class="designer"><b>Produção: </b> {{ resolveProductName(detailItem) || '-' }}</span>
              <br v-if="detailItem.productor" class="mb-2" />
              <span class="designer"><b>Data de Entrada: </b>{{ convertDate(detailItem.createdAt) }}</span>
              <br class="mb-2" />
              <span class="designer"><b>Data de Atualização: </b>{{ convertDate(detailItem.updatedAt) }}</span>
              <br class="mb-2" />

              <span>Observações:</span>
              <div class="card">
                <div class="card-body" v-if="detailItem.comments?.length > 0">
                  <template v-for="comment in detailItem.comments" :key="comment.id">
                    <span><b>{{ comment.userName }}</b> : {{ comment.comment }}</span><br />
                  </template>
                </div>
                <div v-else class="card-body">
                  <p class="text-secondary">Nenhuma observação no momento!</p>
                </div>
              </div>

              <template v-if="detailItem.stage === 'D'">
                <h6 class="mt-3">Enviar para produção:</h6>
                <div class="d-flex justify-content-start mt-2">
                  <button class="btn btn-outline-dark" @click="updateStageProcess(detailItem.id)" :disabled="!machineType[detailItem.id]">
                    <font-awesome-icon icon="gears" /> Enviar
                  </button>
                </div>
              </template>
              <template v-else-if="detailItem.stage !== 'E'">
                <h6 class="mt-3">Mudar Máquina:</h6>
                <div class="d-flex justify-content-start mt-2">
                  <button class="btn btn-outline-dark" @click="updateStageProcess(detailItem.id)" :disabled="!machineType[detailItem.id]">
                    <font-awesome-icon icon="gears" /> Enviar
                  </button>
                </div>
              </template>
            </div>

            <div class="col-md-6 mt-4 mt-md-0" v-if="detailItem.stage !== 'E'">
              <InputSelect
                :key="detailItem.id"
                :objetcSelect="machines"
                :setTitle="'Maquina'"
                :itemId="detailItem.id"
                :disabledClose="disabledClose()"
                :setResult="detailItem.machine"
                @objectId="machineValue"
              />
              <p class="p-error-label">{{ msgError }}</p>

              <label class="mb-2">Percas de Material</label>
              <div class="d-flex align-items-center">
                <input
                  type="number"
                  class="form-control mb-2"
                  placeholder="Largura (metros)"
                  v-model="width[detailItem.id]"
                  :disabled="detailItem.stage === 'D'"
                />
                <input
                  type="number"
                  class="form-control mb-2 ms-2"
                  placeholder="Altura (metros)"
                  v-model="height[detailItem.id]"
                  :disabled="detailItem.stage === 'D'"
                />
              </div>

              <label class="mt-2 form-label d-flex justify-content-start">
                Comentários <small class="text-secondary">(opcional)</small>
              </label>
              <textarea
                v-model="commentsInp[detailItem.id]"
                class="form-control"
                rows="3"
                placeholder="Deixe seu comentário aqui ..."
              ></textarea>

              <p class="mt-4" v-if="detailItem.stage === 'A'">
                <b>{{ `Acabamento: ${detailItem.finishing}.` }}</b>
              </p>

              <h6 class="mt-3" v-if="detailItem.stage === 'P'">Enviar para Acabamento:</h6>
              <div v-if="detailItem.stage === 'P'" class="d-flex flex-row col-12">
                <div class="input-group">
                  <input class="form-control" placeholder="Defina o tipo de acabamento" v-model="finishing[detailItem.id]" />
                  <div class="input-group-append">
                    <button class="btn btn-dark" :disabled="!finishing[detailItem.id]?.length" @click="sendFinishingProcess(detailItem.id)">
                      <font-awesome-icon icon="gears" /> Acabamento
                    </button>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-3">
                <button
                  class="btn btn-outline-dark"
                  @click="registerProcess(detailItem.id)"
                  :disabled="detailItem.stage === 'D'"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                    <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
                    <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                  </svg>
                  Enviar Para Entrega
                </button>
              </div>
            </div>

            <div class="col-md-6 mt-4" v-else>
              <p class="text-secondary mb-0">
                <font-awesome-icon icon="truck-fast" class="me-2" />
                Este serviço já foi enviado para entrega.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">

    <!-- <ImpressionCount
      :users="_users || []"
    /> -->
    <h1 class="text-center mt-4">Serviços de impressão em aberto</h1>

    <div class="row custom-mt">
      <div
        class="col-sm-12 col-lg-12 mb-3"
        v-if="
          user.type_user === 'I' ||
          user.type_user.includes('A') 
        "
      >
        <router-link
          to="/"
          class="btn btn-outline-danger col-2 mb-3"
          @click="backHome"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-bar-left"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
            />
          </svg>
          Voltar
        </router-link>

        <div class="d-flex align-items-center flex-wrap">
          

          <div class="dropdown late-bell-wrapper mb-2 me-3 ms-auto d-flex">
            <button
              class="btn btn-sm btn-outline-light position-relative d-flex align-items-center"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              aria-label="Clientes atrasados"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="#dc3545">
                <path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zM224 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-96l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z"/>
              </svg>
              <span
                v-if="totalLateOrders > 0"
                class="badge rounded-pill bg-danger late-badge"
              >
                {{ totalLateOrders }}
              </span>
            </button>

            <ul class="dropdown-menu dropdown-menu-end late-panel">
              <li class="late-panel-title px-3 py-2">Pedidos de clientes atrasados</li>

              <li class="px-3 py-2" @click.stop>
                <input
                  type="text"
                  class="form-control form-control-sm late-search"
                  placeholder="Buscar por cliente..."
                  v-model="searchLateClient"
                />
              </li>

              <li v-if="clientsWithLate.length === 0" class="px-3 py-2 text-secondary">
                Nenhum serviço atrasado no momento.
              </li>

              <li
                v-else-if="filteredClientsWithLate.length === 0"
                class="px-3 py-2 text-secondary"
              >
                Nenhum cliente encontrado para "{{ searchLateClient }}".
              </li>

              <li v-for="clientItem in filteredClientsWithLate" :key="clientItem.id">
                <a
                  class="dropdown-item late-client-header d-flex justify-content-between align-items-center"
                  href="#"
                  @click.prevent.stop="toggleLateClientExpand(clientItem.id)"
                >
                  <span>
                    <i class="fa-solid fa-triangle-exclamation me-2"></i>
                    {{ clientItem.name }}
                  </span>
                  <span class="d-flex align-items-center">
                    <span class="badge bg-danger me-2">{{ clientItem.lateProcesses.length }}</span>
                    <i
                      class="fa-solid"
                      :class="expandedLateClients[clientItem.id] ? 'fa-chevron-up' : 'fa-chevron-down'"
                    ></i>
                  </span>
                </a>

                <ul v-if="expandedLateClients[clientItem.id]" class="late-client-items">
                  <li
                    v-for="processItem in clientItem.lateProcesses"
                    :key="processItem.id"
                    class="late-client-item d-flex justify-content-between align-items-center"
                  >
                    <span
                      class="clickable"
                      data-bs-toggle="modal"
                      data-bs-target="#processDetailModal"
                      @click="openDetail(processItem)"
                    >
                      N° {{ 1000 + processItem.id }} - {{ getMaterial(processItem) }}
                    </span>
                    <span class="text-secondary small ms-2">{{ convertDate(processItem.createdAt) }}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <button
            :class="`btn btn-sm btn-outline-${status === 'A' ? 'danger' : 'dark'} d-flex align-items-center mb-2 me-3`"
            @click="setStatus"
            :disabled="!!selectedClientId"
          >
            {{status === 'A' ? 'Atrasados' : 'Em dia'}}
          </button>

          <button
            v-if="filteredProcess?.length"
            class="btn btn-sm btn-outline-dark d-flex align-items-center mb-2 me-3"
            @click="opeBlockFilter"
          >
            <font-awesome-icon
              icon="arrow-up-wide-short"
              class="me-2"
              v-if="openFilter"
            />
            <font-awesome-icon icon="arrow-down-wide-short" class="me-2" v-else />
            Filtrar
          </button>
        </div>

        <div
          v-if="selectedClientId"
          class="alert alert-info d-flex justify-content-between align-items-center flex-wrap"
        >
          <span>
            Exibindo <b>histórico completo</b> de <b>{{ nameProcess }}</b>
            (todas as etapas)
          </span>
          <button
            class="btn btn-sm btn-outline-dark mt-2 mt-md-0"
            @click="clearClientFilter"
          >
            Voltar para serviços em aberto
          </button>
        </div>

        <div
          class="d-flex justify-content-end align-items-center mt-2 mb-2"
          v-if="openFilter"
        >
          <div class="form-group me-3 position-relative" style="min-width: 240px;">
            <label for="clientPicker" class="text-dark me-2">Nome do cliente:</label>
            <input
              type="text"
              id="clientPicker"
              name="client-search-no-autofill"
              placeholder="Digite o cliente"
              class="form-control"
              v-model="nameProcess"
              autocomplete="off"
              autocapitalize="off"
              autocorrect="off"
              spellcheck="false"
              role="presentation"
              data-lpignore="true"
              @input="onClientInput"
              @focus="showSuggestions = true"
              @blur="onClientBlur"
            />
            <ul
              v-if="showSuggestions && clientSuggestions.length"
              class="list-group position-absolute w-100 shadow"
              style="z-index: 1000; max-height: 220px; overflow-y: auto;"
            >
              <li
                v-for="client in clientSuggestions"
                :key="client.id"
                class="list-group-item list-group-item-action clickable"
                @mousedown.prevent="selectClient(client)"
              >
                {{ client.name }}
              </li>
            </ul>
            <div v-if="loadingClientHistory" class="text-secondary small mt-1">
              Carregando histórico...
            </div>
          </div>
          <div class="form-group me-3">
            <label for="datePicker" class="text-dark me-2">Data:</label>
            <input
              type="date"
              id="datePicker"
              class="form-control"
              v-model="dateProcess"
              :disabled="!!selectedClientId"
            />
          </div>
          <div class="form-group me-3">
            <label for="statusSelect" class="text-dark me-2">Status:</label>
            <select
              id="statusSelect"
              class="form-select"
              v-model="statusProcess"
              :disabled="!!selectedClientId"
            >
              <option value="" selected>Todos</option>
              <option value="N">Normal</option>
              <option value="U">Urgente</option>
            </select>
          </div>
          <div class="form-group">
            <label for="filtroEtapa" class="text-dark me-2">Etapa:</label>
            <select id="filtroEtapa" class="form-select" v-model="stageProcess2" :disabled="!!selectedClientId">
              <option value="" selected>Todos</option>
              <option value="D">Entrada</option>
              <option value="P">Produção</option>
              <option value="PI">Prod.Individual</option>
              <option value="A">Acabamento</option>
            </select>
          </div>

        </div>
        <div v-show="!loading">
              <div v-if="statusProcess && !filteredProcess?.length">
                  <h6 class="text-secondary custom-mt text-center">
                  Desculpe, não encontramos resultados correspondentes à sua pesquisa.
                  <br />
                  Tente usar termos diferentes ou ajuste os filtros para obter
                  melhores resultados.
                  </h6>
              </div>
              <div v-else-if="!filteredProcess?.length" class="alert alert-light">
                  <h5 class="custom-mt text-center mb-5">
                  <font-awesome-icon icon="circle-exclamation" />
                  Atualmente, não há serviços disponíveis.
                  </h5>
              </div>
          </div>
        <LoadingObjet class="text-center" v-show="loading" />

        <div v-show="!loading" class="process-grid">
          <template v-for="item in filteredProcess" :key="item.id">
            <div class="card process-card text-dark bg-white">
              <div class="d-flex justify-content-between align-items-center card-header py-2 px-3 bg-dark text-white">
                <span class="fw-bold">
                  <font-awesome-icon
                    icon="eye"
                    class="me-1 clickable"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    @click="showImage(item.id)"
                  />
                  N° {{ item.id + 1000 }}
                </span>
                <span :class="`status badge bg-${item.status == 'U' ? 'danger' : 'success'}`">
                  {{ typeStatus(item.status) }}
                </span>
              </div>
              <div class="card-body py-2 px-3">
                <span :class="`status badge bg-${backgroundColorStage(item.stage)} mb-2`">
                  {{ stateFormat(item) }}
                </span>
            
                <div class="small text-truncate"><b>Material:</b> {{ getMaterial(item) }}</div>
                <div class="small text-truncate"><b>Cliente:</b> {{ resolveClientName(item) || '-' }}</div>
                <div class="small text-secondary mb-1" v-if="user.type_user === 'A' && item.clientFone">
                  {{ formatFone(item.clientFone) }}
                </div>
                <div class="small text-secondary mb-2">{{ convertDate(item.createdAt) }}</div>

                <div class="d-flex justify-content-between align-items-center">
                  <font-awesome-icon
                    v-if="item.stage !== 'E'"
                    icon="truck-fast"
                    :class="`text-success fs-5 ${item.stage === 'D' ? 'icon-disabled' : 'clickable'}`"
                    title="Finalizar entrega"
                    @click="item.stage !== 'D' && registerProcess(item.id)"
                  />
                  <span v-else class="text-secondary small">
                    <font-awesome-icon icon="truck-fast" class="me-1" />Entregue
                  </span>

                  <button
                    class="btn btn-sm btn-dark"
                    data-bs-toggle="modal"
                    data-bs-target="#processDetailModal"
                    @click="openDetail(item)"
                  >
                    Detalhes
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>

      </div>
    </div>
   </div>

</template>

<script>
import store from "@/store";
import { computed, onBeforeMount, onMounted, onUnmounted, reactive, ref } from "vue";

import {
  createProcessPrinter,
  stageProcess,
  editLackMaterial,
  createLackMaterial,
  finishingProcess,
  midiaDownloadProcess,
  checkMidiaExists
} from "@/http";

import md5 from "md5";

import { 
  convertDate, 
  formatFone, 
  getDateBrazil, 
  getImgBase64,
  normalizeText
} from "@/utils";

import { 
  sendEventStageProcess, 
  getReponseProcess, 
  getReponseStageProcess,
  getReponseMachine,
} from "@/socket";
import { getterENV } from "@/environment";
import { socket } from "@/socket";
import InputSelect from "@/components/InputSelect.vue";
import LoadingObjet from '@/components/LoadingObjet';
// import ImpressionCount from '@/components/charts/ImpressionCount';
export default {
  name: "ExecuteProcesses",
  props: {},

  setup() {
    const user = computed(() => store.state.userCurrent);
    const _users = computed(() => store.state.users);

    const comments = ref({});
    const commentsInp = ref({});
    const machineType = ref({});
    const msgError = ref(null);
    const status = ref('A');
    const machines = computed(() => store.state.machineList);
    const lackMaterialPayload = ref({
      material: 0,
      width: 0,
      height: 0,
      nameMaterial: ''
    });

    const width = ref({});
    const height = ref({});

    const finishing = ref({});
    const hasMidia = ref({});

    const detailItem = ref(null);
    const detailCloseBtn = ref(null);

    const clearItemState = (id) => {
      delete machineType.value[id];
      delete commentsInp.value[id];
      delete width.value[id];
      delete height.value[id];
      delete finishing.value[id];
    };

    const openDetail = async (item) => {
      detailItem.value = item;
      selectedImg.value = '';
      msgError.value = null;
      selectedImg.value = await getImgBase64(item.id);
      hasMidia.value[item.id] = await checkMidiaExists(item.id);
    };

    const closeDetailModal = () => {
      detailCloseBtn.value?.click();
    };

    const sortProcess = (arr) => {
      return arr?.sort((a, b) => {
        return b.id - a.id;
      });
    };

    const applyCommentsFromResponse = (listProcesses) => {
      if (!listProcesses?.length) return;
      for (const item of listProcesses) {
        if (item.comments?.length) {
          comments.value[item.id] = item.comments;
        }
      }
    };

    const getNameUser = (id) => {
      const foundUser = _users.value.find((user) => user.id == id);
      return foundUser?.name;
    };

    const typeStatus = (type) => {
      switch (type) {
        case "U":
          return "Urgente";
        case "N":
          return "Normal";
      }
    };

    const registerLackMaterial = async (id,process) => {
      lackMaterialPayload.value.width = width.value[id];
      lackMaterialPayload.value.height = height.value[id];
      lackMaterialPayload.value.material = process?.material;
      lackMaterialPayload.value.nameMaterial = getMaterial(process, true);

      const requestLackMaterial = await createLackMaterial(lackMaterialPayload.value); 
      if(requestLackMaterial?.exist){
        requestLackMaterial.lackMaterial.height += lackMaterialPayload.value.height;
        requestLackMaterial.lackMaterial.width += lackMaterialPayload.value.width;
        await editLackMaterial(requestLackMaterial.lackMaterial.id, requestLackMaterial.lackMaterial);
      }

      lackMaterialPayload.value = {
        material: 0,
        width: 0,
        height: 0,
        nameMaterial: ''
      }
    }

    const refreshProcessLists = async () => {
      const listProcesses = await store.dispatch("setProcessListLecturerPrinterCurrent", {data: { stage: ["D", "P", "A"] }, status: 'A', date: getDateBrazil()});
      applyCommentsFromResponse(listProcesses);

      const lateProcesses = await store.dispatch("setProcessListLecturerPrinterLateCurrent", {data: { stage: ["D", "P", "A"] }, date: getDateBrazil()});
      applyCommentsFromResponse(lateProcesses);

      return listProcesses;
    };

    const registerProcess = async (id) => {

      if (!machineType.value) {
        msgError.value = "Campo obrigatório.";
        return;
      }

      const processFind =
        store.state.executeProcessesPrinter?.find(process => process.id == id) ||
        store.state.executeProcessesPrinterLate?.find(process => process.id == id);


      const payload = {
          machine: machineType.value[id],
          comment: commentsInp.value[id],
          member: user.value.id,
      };

      const reponseProcessPrinter = await createProcessPrinter(id, payload);

      if (reponseProcessPrinter?.status) {
          if(processFind){
              processFind.stage = "E";
              sendEventStageProcess("graphic", processFind);
          }

          await refreshProcessLists();
          await registerLackMaterial(id, processFind);
          closeDetailModal();
          clearItemState(id);
          return;
      }
    };

    const findById = (list, id) => (list || []).find((it) => it?.id == id);

    const resolveClientName = (item) => {
      if (item?.clientName) return item.clientName;
      if (selectedClientId.value) return nameProcess.value;
      const client = findById(store.state.clientsList, item?.client);
      return client?.name || null;
    };

    const findClient = (item) => {
      const name = resolveClientName(item);
      return name
        ? `${name}${user.value.type_user === "A" ? (' - ' + formatFone(item.clientFone || '')) : ''}`
        : "-";
    };

    const resolveDesignerName = (item) => {
      return item?.designerName || getNameUser(item?.designer) || '-';
    };

    const resolveProductName = (item) => {
      return item?.productName || getNameUser(item?.productor) || null;
    };

    const downloadMidia = (id) => {
      const url = midiaDownloadProcess(id);
      window.open(url, '_blank');
    };

    const openFilter = ref(false);

    const opeBlockFilter = () => {
      openFilter.value = openFilter.value ? false : true;
    };

    const dataProcesses = computed(() => {
      return store.getters.getProcessesPrinterAll || [];
    });

    const isLate = (item) => new Date(item.createdAt) < new Date(getDateBrazil());

    const clientsWithLate = computed(() => {
      const source = dataProcesses.value || [];
      const map = new Map();

      for (const processItem of source) {
        if (!isLate(processItem)) continue;

        const clientName = resolveClientName(processItem) || 'Cliente não identificado';
        const clientId = processItem?.client ?? `_${clientName}`;

        if (!map.has(clientId)) {
          map.set(clientId, { id: clientId, name: clientName, lateProcesses: [] });
        }

        map.get(clientId).lateProcesses.push(processItem);
      }

      return Array.from(map.values());
    });

    const totalLateOrders = computed(() =>
      clientsWithLate.value.reduce((total, clientItem) => total + clientItem.lateProcesses.length, 0)
    );

    const searchLateClient = ref("");

    const filteredClientsWithLate = computed(() => {
      const search = normalizeText(searchLateClient.value || "");
      if (!search) return clientsWithLate.value;

      return clientsWithLate.value.filter((clientItem) =>
        normalizeText(clientItem.name || "").includes(search)
      );
    });

    const expandedLateClients = reactive({});

    const toggleLateClientExpand = (clientId) => {
      expandedLateClients[clientId] = !expandedLateClients[clientId];
    };

    const statusProcess = ref("");
    const dateProcess = ref("");
    const nameProcess = ref("");
    const stageProcess2 = ref("");

    const clientsList = computed(() => store.state.clientsList || []);
    const showSuggestions = ref(false);
    const selectedClientId = ref(null);
    const loadingClientHistory = ref(false);

    const clientSuggestions = computed(() => {
      const term = normalizeText(nameProcess.value || "");
      if (!term || selectedClientId.value) return [];
      return clientsList.value
        .filter((client) => normalizeText(client.name || "").includes(term))
        .slice(0, 8);
    });

    const onClientInput = () => {
      if (selectedClientId.value) {
        selectedClientId.value = null;
        store.commit('setListProcessesOrders', []);
      }
      showSuggestions.value = true;
    };

    const onClientBlur = () => {
      setTimeout(() => {
        showSuggestions.value = false;
      }, 150);
    };

    const selectClient = async (client) => {
      nameProcess.value = client.name;
      selectedClientId.value = client.id;
      showSuggestions.value = false;
      loadingClientHistory.value = true;

      if (!store.state.materialList?.length) {
        await store.dispatch('setMaterialListCurrent');
      }

      if (!_users.value?.length) {
        await store.dispatch('getUsers');
      }

      await store.dispatch("getListProcessesOrders", client.id);
      loadingClientHistory.value = false;
    };

    const clearClientFilter = () => {
      nameProcess.value = "";
      selectedClientId.value = null;
      store.commit('setListProcessesOrders', []);
    };

    const filteredProcess = computed(() => {
      try {
        if (selectedClientId.value) {
          return sortProcess([...(store.state.listProcessesOrders || [])]) || [];
        }

        const formatLabelDate = (date) => {
          const arrDate = date?.split("-");
          return date ? arrDate[2] + "/" + arrDate[1] + "/" + arrDate[0] : "";
        };

        const _statusProcess = statusProcess.value;
        const _dateProcess = formatLabelDate(dateProcess.value);
        const _nameClient = normalizeText(nameProcess.value);
        const _stageProcess = stageProcess2.value;

        const usingOtherFilters = !!(nameProcess.value || dateProcess.value || _statusProcess || _stageProcess);

        return dataProcesses?.value?.filter((process) => {
          const matchBase =
            process?.status?.includes(_statusProcess) &&
            normalizeText(process?.clientName || '').includes(_nameClient) &&
            (process.stage?.includes(_stageProcess) || (process.stage == 'P' && _stageProcess == 'PI' && process.productor == user.value.id));

          const matchDate = _dateProcess ? convertDate(process?.createdAt).includes(_dateProcess) : true;
          const matchToggle = usingOtherFilters ? true : (status.value === 'A' ? !isLate(process) : isLate(process));

          return matchBase && matchDate && matchToggle;
        }) || [];
      } catch (e) {
        return [];
      }
    });

    const updateStageProcess = async (id) => {
      let typeStage = "P" ;

      await stageProcess(id, typeStage, machineType.value[id], user.value.id)
        .then(async () => {
          sendEventStageProcess("graphic", {id:id, stage: typeStage, machine: machineType.value[id]});
          await refreshProcessLists();
          store.commit('setSendPrint');
          closeDetailModal();
          delete machineType.value[id];
      });

    };

    const sendFinishingProcess = async (id) => {

    const payload = {
      finishing: finishing.value[id],
      member: user.value.id,
      stage:  "A",
      comment: commentsInp.value[id] 
    }

    await finishingProcess(id, payload)
      .then( async () => {
          sendEventStageProcess("graphic", {id:id, stage: "A"});
          await refreshProcessLists();
          closeDetailModal();
          delete finishing.value[id];
          delete commentsInp.value[id];
        }
      );

  }

    const selectedImg = ref('');
    const showImage = async (id) => {
      selectedImg.value = '';
      selectedImg.value = await getImgBase64(id);
    }
    const backgroundColorStage = (stage) => {
      if (stage == 'D' )  return 'dark';
      if (stage == 'P' || stage == 'C')  return 'warning';
      if (stage == 'I' || stage == 'A') return 'primary';
      if (stage == 'E' )  return 'success';
  }
    const stateFormat = (item) => {

      if (item?.finished == 1) {
        return "Concluído";
      }

      switch (item?.stage) {
        case "D":
          return "Entrada";
        case "I":
          return "Conferente";
        case "C":
          return "Concluído";
        case "P":
          return "Produção";
        case "A":
          return "Acabamento";
        case "E":
          return "Aguardando Entrega";
      }
  };

    const setStatus = () => {
      status.value = status.value === 'A' ? 'P':  'A';
    }

    const getMaterial = (item, lonlyName=false) => {
      let name = item?.materialName;

      if (!name) {
        const material = findById(store.state.materialListView, item?.material);
        name = material?.name;
      }

      if (!name) {
        return '-';
      }

      if (lonlyName) {
        return name;
      }

      return `${name}${name ? ' ' : ''}${item?.amount > 1 ? (item?.amount + 'X ' || '-') : ''}${item?.height || '-'}${item?.height ? 'X' : ''}${item?.width || '-'}`;
    };

    const machineValue = (event) => {
      machineType.value[event?.item] = event?.id 
    }

    const disabledClose = () => {
      return false
    }
    const loading = ref(false);

    onBeforeMount(async () => {
      loading.value = true;

      if (!store.state.clientsList?.length) {
        store.dispatch("setClientListCurrent");
      }
      if (!_users.value?.length) {
        store.dispatch("getUsers");
      }

      const listProcesses = await store.dispatch("setProcessListLecturerPrinterCurrent", {data: { stage: ["D", "P", "A"] }, status: 'A', date: getDateBrazil()});

      if(!listProcesses?.message){
        const processIds = listProcesses.map((item)=> item.material) || [];
        await store.dispatch('getMaterialListView', processIds);
        applyCommentsFromResponse(listProcesses);
      }

      loading.value = false;

      store.dispatch("setProcessListLecturerPrinterLateCurrent", {data: { stage: ["D", "P", "A"] }, date: getDateBrazil()});
    });

    onMounted(() =>{
      getReponseMachine();
      getReponseProcess();
      getReponseStageProcess();
    });

    onUnmounted(() => {
      socket.off(getterENV.socket.machine.GET_MACHINE);
      socket.off(getterENV.socket.process.GET_PROCESS);
      socket.off(getterENV.socket.process.GET_PROCESS_STAGE);
    });

    return {
      backgroundColorStage,
      stageProcess2,
      loading,
      disabledClose,
      machineValue,
      machines,
      getMaterial,
      selectedImg,
      setStatus,
      status,
      showImage,
      hasMidia,
      downloadMidia,
      filteredProcess,
      updateStageProcess,
      user,
      _users,
      comments,
      sortProcess,
      getNameUser,
      typeStatus,
      commentsInp,
      machineType,
      registerProcess,
      msgError,
      opeBlockFilter,
      openFilter,
      statusProcess,
      dateProcess,
      convertDate,
      formatFone,
      md5,
      findClient,
      resolveClientName,
      nameProcess,
      lackMaterialPayload,
      width, 
      height,
      finishing,
      sendFinishingProcess,
      stateFormat,
      clientsList,
      showSuggestions,
      selectedClientId,
      loadingClientHistory,
      clientSuggestions,
      onClientInput,
      onClientBlur,
      selectClient,
      clearClientFilter,
      resolveDesignerName,
      resolveProductName,
      detailItem,
      detailCloseBtn,
      openDetail,
      clientsWithLate,
      filteredClientsWithLate,
      totalLateOrders,
      searchLateClient,
      expandedLateClients,
      toggleLateClientExpand,
    };
  },
  components:{
    InputSelect,
    LoadingObjet,
    // ImpressionCount,
  }
};
</script>
<style scoped>
.custom-mt {
  margin-top: 50px;
}

.card-header {
  font-family: Arial, Helvetica, sans-serif;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
}

.status {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.9rem;
  padding: auto;
}

.produto {
  font-size: 1rem;
}

.btn {
  font-weight: bold;
}

.p-error-label {
  font-size: 14px;
  color: red;
}

.clickable {
  cursor: pointer;
}

.clickable :hover {
  opacity:  0.75;
}

.icon-disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.overlay-background {
  background-color: rgba(0, 0, 0, 0.5); 
}
.overlay-background2 {
  background-color: rgba(0, 0, 0, 0); 
}

.modal-dialog {
  max-width: 100%;
  max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  width: auto;
  height: auto;
  max-width: 80%;
  max-height: 80%;
}

.modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
}

.enlarged-image {
  width: auto;
  height: auto;
  max-width: 90vw;
  max-height: 75vh;
  object-fit: contain;
}

.detail-thumb-wrapper {
  position: relative;
  flex-shrink: 0;
}

.detail-thumb {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
}

.detail-thumb-placeholder {
  width: 72px;
  height: 72px;
  background: #f0f0f0;
  border-radius: 8px;
}

.detail-thumb-download {
  position: absolute;
  bottom: -6px;
  right: -6px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: #2c2c2c;
  color: #fff;
  font-size: 0.65rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.detail-thumb-download:hover { background: #000; }

.process-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem;
  margin-top: 1rem;
}

.process-card {
  min-height: 200px;
}

.process-card .card-header {
  font-size: 1rem;
}

#processDetailModal .modal-content,
#processDetailModal .modal-body {
  display: block;
}

.container {
  padding-bottom: 4rem;
}

.late-bell-wrapper .btn {
  font-size: 14px;
  padding: 6px 10px;
  border: 1px solid #000;
}

.late-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  font-size: 10px;
  padding: 3px 6px;
}

.late-panel {
  background-color: #212529;
  min-width: 300px;
  max-height: 400px;
  overflow-y: auto;
  padding: 0;
}

.late-panel-title {
  color: white;
  font-weight: bold;
  border-bottom: 1px solid #3a3a3a;
}

.late-client-header {
  color: white;
}

.late-client-header:hover {
  background-color: #2c3034;
  color: #bdbdbd;
}

.late-client-items {
  list-style: none;
  padding: 4px 16px 8px 44px;
  margin: 0;
  background-color: #17191c;
}

.late-client-item {
  color: #cfcfcf;
  font-size: 13px;
  padding: 4px 0;
}

.late-search {
  background-color: #17191c;
  color: white;
  border: 1px solid #3a3a3a;
}

.late-search::placeholder {
  color: #8c8a8a;
}

.late-search:focus {
  background-color: #17191c;
  color: white;
  border-color: #5f5e5a;
  box-shadow: none;
}

@media (max-width: 992px) {
  .process-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .process-grid {
    grid-template-columns: 1fr;
  }
}
</style>